module.exports = __webpack_public_path__ + "static/media/quickstart-step-3.9095148e.jpg";